import React, { useState } from 'react';
import { FiMail, FiMapPin, FiSend, FiCheck, FiAlertCircle } from 'react-icons/fi';
import './Contact.css';

const API_BASE = 'https://dating-app-1-ij4w.onrender.com/api';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
        setTimeout(() => setStatus(null), 5000);
      } else {
        setStatus('error');
        setErrorMsg(data.error || 'Something went wrong');
      }
    } catch (err) {
      setStatus('error');
      setErrorMsg('Network error. Please try again.');
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Contact</span>
          <h2>Get in <span className="gradient-text">Touch</span></h2>
          <p>Have questions or feedback? We'd love to hear from you.</p>
        </div>
        <div className="contact-grid">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Your Name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                disabled={status === 'loading'}
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                placeholder="Your Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                disabled={status === 'loading'}
              />
            </div>
            <div className="form-group">
              <textarea
                placeholder="Your Message"
                rows="5"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                required
                disabled={status === 'loading'}
              ></textarea>
            </div>
            <button type="submit" className="contact-btn" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending...' : <><FiSend /> Send Message</>}
            </button>
            {status === 'success' && (
              <div className="form-status success">
                <FiCheck /> Message sent successfully! We'll get back to you soon.
              </div>
            )}
            {status === 'error' && (
              <div className="form-status error">
                <FiAlertCircle /> {errorMsg}
              </div>
            )}
          </form>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-item-icon">
                <FiMail />
              </div>
              <div>
                <strong>Email Us</strong>
                <span>slink@astergo.in</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-item-icon">
                <FiMapPin />
              </div>
              <div>
                <strong>Location</strong>
                <span>Kolkata, West Bengal, India</span>
              </div>
            </div>
            <div className="contact-cta">
              <h4>Ready to start earning?</h4>
              <p>Download Slink now and start making money on video calls today.</p>
              <a href="https://slink.astergo.in/slink-dating-app.apk" className="contact-download-btn">
                Download for Android
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
